import { useEffect, useState } from 'react';
import { useGlobalOnEscapeKey } from 'primereact/hooks';

// An open dropdown or multiselect list (PrimeReact renders it as a portal with a listbox).
const OPEN_LIST = '[data-pc-section="panel"] [role="listbox"]';
// PrimeReact's ESC_KEY_HANDLING_PRIORITIES.OVERLAY_PANEL (600; exported at runtime but missing from its
// types): above dialogs (300), below tooltips. The second number is past any display order PrimeReact assigns.
const PRIORITY: [number, number] = [600, Number.MAX_SAFE_INTEGER];
// The list closes itself on Esc (its input handles the key), so the guard only has to win the
// global Esc handling; it does nothing else.
const keepDialogOpen = () => {};

/**
 * Esc on an open Dropdown/MultiSelect list inside a Dialog closes only the list.
 * PrimeReact routes Esc to the highest-priority open overlay, but Dropdown and MultiSelect don't
 * take part, so the Dialog behind them closed too (losing the user's place). Mount once.
 */
const OverlayEscapeGuard = () => {
  const [listOpen, setListOpen] = useState(false);
  useEffect(() => {
    const check = () => setListOpen(!!document.querySelector(OPEN_LIST));
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    check();
    return () => observer.disconnect();
  }, []);
  useGlobalOnEscapeKey({ callback: keepDialogOpen, when: listOpen, priority: PRIORITY });
  return null;
};

export default OverlayEscapeGuard;
